import { SearchOutlined } from '@mui/icons-material';
import { Box, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import ReusableTable from '../../common/table/CommonTable';
import CustomTextField from '../../common/textfield/CommonTextField';
import { fetchHistoryPatients } from '../../redux/patient/patientAction';

const HistoryList = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [patientFilter, setPatientFilter] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setLoading(true);
    dispatch(fetchHistoryPatients(currentPage));
  }, [dispatch, currentPage]);

  const historyState = useSelector((state) => state?.patients?.historyPatient || {});
  const historyData = historyState?.data?.data || [];
  
const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return 'N/A';
  const date = new Date(dateTimeString.split('-').reverse().join('-'));
  return date.toLocaleString('en-GB', { hour12: true });
};
  
  useEffect(() => {
    if (historyData.length > 0) {
      const processedData = historyData.map(item => ({
        id: item.id,
        serialNumber: item.Patient?.patient_serial_no || 'Unknown',
        patientName: item.Patient?.patient_name || 'Unknown',
        attendantName: item.Attender?.attender_name || 'Unknown',
        status: item.attender_status === 2 ? 'In' : 'Out',
        block: item.Block?.block_name || 'Unknown',
        floor: item.Floor?.floor_name || 'Unknown',
        ward: item.Ward?.ward_name || 'Unknown',
        inTime: formatDateTime(item.in_time),
        outTime: formatDateTime(item.out_time)
      }));
      
      setFilteredData(processedData);
      setLoading(false);
    }
  }, [historyData]);

  useEffect(() => {
    if (historyData.length > 0) {
      const processedData = historyData.map(item => ({
        id: item.id,
        serialNumber: item.Patient?.patient_serial_no || 'Unknown',
        patientName: item.Patient?.patient_name || 'Unknown',
        attendantName: item.Attender?.attender_name || 'Unknown',
        status: item.attender_status === 2 ? 'In' : 'Out',
        block: item.Block?.block_name || 'Unknown',
        floor: item.Floor?.floor_name || 'Unknown',
        ward: item.Ward?.ward_name || 'Unknown',
        inTime: formatDateTime(item.in_time),
        outTime: formatDateTime(item.out_time)
      }));
      
      if (patientFilter.trim() === '') {
        setFilteredData(processedData);
      } else {
        const filtered = processedData.filter(record => 
          record.patientName.toLowerCase().includes(patientFilter.toLowerCase())
        );
        setFilteredData(filtered);
      }
    }
  }, [patientFilter, historyData]);

  const handlePatientFilterChange = (event) => {
    setPatientFilter(event.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const columns = [
    { id: 'serialNumber', label: 'ID', sortable: true, width: '60px' },
    { id: 'patientName', label: 'Patient Name', sortable: true },
    { id: 'attendantName', label: 'Attendant Name', sortable: true },
    {
      id: 'status',
      label: 'In/Out',
      sortable: true,
      width: '80px',
      render: (status) => (
        <Box
          sx={{
            backgroundColor: status === 'In' ? 'green' : 'red',
            borderRadius: 1,
            px: 1,
            py: 0.5,
            display: 'inline-block',
            color: 'white',
          }}
        >
          {status}
        </Box>
      )
    },
    { id: 'block', label: 'Block', sortable: true },
    { id: 'floor', label: 'Floor', sortable: true },
    { id: 'ward', label: 'Ward', sortable: true },
    { id: 'inTime', label: 'In Time', sortable: true },
    { id: 'outTime', label: 'Out Time', sortable: true },
  ];
  
  return (
    <Box>
      <Grid container spacing={2} mt={3}>
        <Grid item xs={12} md={6}>
        </Grid>
        <Grid item xs={12} md={6}>
          <CustomTextField
            label="Filter by Patient Name"
            variant="outlined"
            value={patientFilter}
            onChange={handlePatientFilterChange}
            sx={{ mb: 3 }}
            placeholder="Type to search patients..."
            InputProps={{
              startAdornment: (
                <SearchOutlined sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
              ),
            }}
          />
        </Grid>
      </Grid>

      <ReusableTable
        title={`Attendant History${patientFilter ? ` (Filtered by: ${patientFilter})` : ''}`}
        columns={columns}
        data={filteredData}
        isLoading={loading}
        headerColor="#000"
        rowColor="#ffffff"
        alternateRowColor="#f5f5f5"
        withPagination={true}
        rowsPerPage={10}
        totalPages={historyState?.data?.totalPages || 1}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        withActions={false}
        showDownloadOption={true} 
      />
    </Box>
  );
};

export default HistoryList;